export const termsData = [
    {
      title: "Introduction",
      content: `The Unifycare Site Terms of Use describe when and the conditions
        under which you are allowed to access or use the Site. Please read
        these Site Terms of Use carefully before visiting our Site. Some
        visitors to our Site simply visit the publicly available portions of
        our Site or use the Public Site Services (“you” or “Site Visitors”).
        If you do not agree to these Site Terms of Use, you may not visit,
        use, or access the Site or Site Services as a Site Visitor, User or
        otherwise and may not click to accept the Terms of Service when
        prompted on the Site.`,
    },
    {
      title: "Licenses and third-party content",
      content: `Unifycare grants you a limited license to access the Site and Site
        Services. This license is subject to and conditioned on compliance
        with the Site Terms of Use and, to the extent applicable, the rest
        of the Terms of Service. We try to keep our Site and the Site
        Services safe, secure, and functioning properly, but we cannot
        guarantee the continuous operation of or access to our Services. In
        fact, we might even stop providing the Site or Site Services
        completely or stop providing certain features without notice.
        Unifycare may terminate any license it has granted to any Site
        Visitor or User to access the Site and Site Services by providing
        notice, and the termination of such license shall be effective
        immediately upon Unifycare providing such notice. Unifycare and our
        licensors retain all right, title, and interest in and to all
        Intellectual Property Rights related in and to the Site and the Site
        Services. The Unifycare logos and names are trademarks of Unifycare
        and are registered in certain jurisdictions. All other product
        names, company names, marks, logos, and symbols on the Site or Site
        Services may be the trademarks of their respective owners. Nothing
        in the Terms of Service grants you a right to use any Unifycare
        Marks. You are solely responsible for your use of the Site and any
        content you post on the Site, and that if someone makes a claim
        against Unifycare because of your content that you will pay
        Unifycare for our fees and expenses, as detailed below: When you post
        User Content on the Site or through the Site Services or provide
        Unifycare with User Content, you understand and acknowledge that you
        are solely responsible for such User Content. Further, you represent
        and warrant that you have the right, power, and authority to (a)
        post that User Content without violating the rights of third
        parties, and (b) grant the licenses specified below. You acknowledge
        and agree that the poster of User Content, and not Unifycare, is
        responsible for any User Content including any harms caused to you,
        another User, or a third party by such User Content. You will
        indemnify, defend, and hold harmless Unifycare, our Affiliates, and
        our respective directors, officers, employees, representatives, and
        agents (each an “Indemnified Party”) from any and all claims,
        damages, liabilities, costs, losses, and expenses (including, but
        not limited to, reasonable attorneys’ fees and all related costs and
        expenses) arising from or relating to any claim, suit, proceeding,
        demand, or action brought by you or a third party or other User
        against an Indemnified Party relating to or arising out of any User
        Content you post. You retain all ownership rights in any User
        Content you post on Unifycare. To the extent permitted by applicable
        law, you also grant to Unifycare and our successors and Affiliates a
        royalty-free, sub-licensable, transferable, perpetual, irrevocable,
        non-exclusive, worldwide license to use, reproduce, modify, publish,
        list information regarding, edit, translate, distribute, publicly
        perform, publicly display, and make derivative works of all such
        User Content and your name, voice, and/or likeness as contained in
        your User Content, in whole or in part, and in any form, media, or
        technology, whether now known or hereafter developed, for use in
        connection with the Site and Unifycare’s, our successors’ and
        Affiliates’ businesses, including, without limitation, for promoting
        and redistributing part or all of the Site (and derivative works
        thereof) in any media formats and through any media channels. You
        also hereby grant each User and each Site Visitor a non-exclusive
        license to access your User Content through the Site and to use,
        reproduce, distribute, and display such User Content to the extent
        permitted through the normal functionality of the Site and subject
        to all applicable confidentiality and other provisions of the Terms
        of Service, our Privacy Policy, and applicable law. You may submit
        comments or ideas about the Site and Site Services, including
        without limitation about how to improve the Site or Site Services
        (collectively, “Ideas”). By submitting any Ideas, you agree that:
        (a) your disclosure is voluntary, gratuitous, unsolicited, and
        without restriction and will not place Unifycare under any fiduciary
        or other obligation, (b) your Ideas do not contain the confidential
        or proprietary information of third parties, and (c) you grant us a
        perpetual and royalty-free license to use the Ideas without any
        additional compensation to you and to disclose the Ideas on a
        non-confidential basis or otherwise to anyone. You further
        acknowledge and agree that, by acceptance of your submission,
        Unifycare does not waive any rights to use similar or related ideas,
        including those known or developed by Unifycare or obtained from
        sources other than you. Any information or content expressed or made
        available by a third party or any other Site Visitor or User is that
        of the respective author(s) or distributor(s) and not of Unifycare.
        Unifycare neither endorses nor is responsible for the accuracy or
        reliability of any opinion, advice, information, or statement made
        on the Site by anyone other than Unifycare’s authorized agents
        acting in their official capacities. The Site may contain links to
        third-party websites. The Site may also contain applications that
        allow you to access third-party websites via the Site. Such
        third-party websites or applications are owned and operated by the
        third parties and/or their licensors. The inclusion of any link or
        application on the Site does not imply that we endorse the linked
        site or application. You use the links and third-party websites at
        your own risk and agree that your use of an application or
        third-party website accessed via the Site is on an “as is” and “as
        available” basis without any warranty for any purpose. Unifycare is
        committed to complying with India copyright and related laws and
        requires all Site Visitors and Users to comply with these laws.
        Accordingly, you may not use the Site to store any material or
        content, or disseminate any material or content, in any manner that
        constitutes an infringement of third party intellectual property
        rights, including rights granted by India copyright law.If you are
        the owner of any copyrighted work and believe your rights under
        India copyright law have been infringed by any material on the Site,
        you may take advantage of certain provisions of the Digital
        Millennium Copyright Act (the 'DMCA') by complying with Unifycare’s
        Proprietary Rights Infringement Reporting Procedures.`,
    },
    {
      title: "Permitted site uses",
      content: `We reserve the right, but do not assume the obligation, to
        investigate any potential violation of this or any other potential
        violation of these Site Terms of Use and to remove, disable access
        to, or modify any content on the Site. Our failure to act with
        respect to a breach by you or others does not waive our right to act
        with respect to subsequent or similar breaches. We do not guarantee
        we will take action against all breaches of these Terms of Use or
        the User Agreement. If you become aware of any violation of these
        Site Terms or Use, you must immediately report it to Customer
        Service. You agree to assist us with any investigation we undertake
        and to take any remedial steps we require in order to correct a
        violation of these Site Terms of Use.`,
    },
  ];